export const BRAND = {
  name: "BRICKSPACE",
  tagline: "Independent Real Estate Consultancy",
  domain: "brickspace.co.in",
  url: "https://brickspace.co.in",
  phone: "+918796521119",
  phoneDisplay: "+91 87965 21119",
  whatsapp: "918796521119",
  email: "hello@brickspace.co.in",
  address: "NH-24, Delhi–Meerut Expressway Corridor, Ghaziabad, Uttar Pradesh",
  locality: "NH-24 / Delhi–Meerut Expressway, Ghaziabad",
  // Google Ads conversion tracking - inactive until IDs are supplied
  ads: { conversionId: "", conversionLabel: "" },
};

export const waLink = (text = "Hi BRICKSPACE, I'd like advice on property along NH-24.") =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(text)}`;

export const leadWaLink = (lead) =>
  `https://wa.me/${(lead.whatsapp || lead.phone || "").replace(/[^0-9]/g, "")}?text=${encodeURIComponent(
    `Hello ${lead.name}, this is ${BRAND.name} — your real estate advisory partner for the NH-24 corridor.`
  )}`;

export const CORRIDORS = [
  {
    key: "wave_city",
    label: "Wave City",
    index: "01",
    blurb:
      "India's largest integrated hi-tech township on NH-24. Plots, low-rise and premium apartments with in-township schools and clubs.",
    stats: [
      { k: "Ticket size", v: "₹45L – 1.6Cr" },
      { k: "Inventory", v: "Plots · Villas · Apartments" },
      { k: "Drive to Anand Vihar", v: "28 min" },
    ],
  },
  {
    key: "aditya_world_city",
    label: "Aditya World City",
    index: "02",
    blurb:
      "Mature township with delivered inventory, established social infrastructure and a strong resale and rental market.",
    stats: [
      { k: "Ticket size", v: "₹55L – 2.1Cr" },
      { k: "Inventory", v: "Villas · Apartments" },
      { k: "Possession", v: "Ready to move" },
    ],
  },
  {
    key: "siddharth_vihar",
    label: "Siddharth Vihar",
    index: "03",
    blurb:
      "The fastest-appreciating pocket on the Delhi–Meerut Expressway. Premium high-rises minutes from Indirapuram and Vaishali metro.",
    stats: [
      { k: "Ticket size", v: "₹75L – 2.4Cr" },
      { k: "Inventory", v: "Premium high-rise" },
      { k: "Metro", v: "Vaishali · 12 min" },
    ],
  },
];

export const BUDGETS = ["40L - 60L", "60L - 85L", "85L - 1.2Cr", "1.2Cr - 2Cr", "2Cr+"];
export const TIMELINES = ["Immediate", "1-3 months", "3-6 months", "Just exploring"];
export const PROPERTY_TYPES = ["apartment", "villa", "plot", "commercial"];

export const STAGES = [
  { key: "new", label: "New Lead", accent: "#1DBF73" },
  { key: "contacted", label: "Contacted", accent: "#0EA5E9" },
  { key: "site_visit_scheduled", label: "Visit Scheduled", accent: "#8B5CF6" },
  { key: "site_visit_done", label: "Visit Done", accent: "#F59E0B" },
  { key: "negotiation", label: "Negotiation", accent: "#EF6820" },
  { key: "closed", label: "Booking Closed", accent: "#16A34A" },
  { key: "dropped", label: "Cold / Dropped", accent: "#95979D" },
];

export const stageLabel = (key) => STAGES.find((s) => s.key === key)?.label || key;
export const corridorLabel = (key) =>
  CORRIDORS.find((c) => c.key === key)?.label || (key === "other" ? "Other" : key);
